import { createLazyComponent, LazyModule } from 'owa-bundling';
import addNotification from './actions/addNotification';
import removeNotification from './actions/removeNotification';
import { default as headerToastNotificationStore } from './store/store';
import { CALL_NOTIFICATION_TYPE, IM_NOTIFICATION_TYPE, SUMMARY_NOTIFICATION_TYPE, } from './utils/constants';
import { ensureNotificationHandlerRegistered } from './utils/notificationHandler';
import { NotificationActionType, } from './store/schema/NotificationViewState';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "NotificationToast" */ './lazyIndex');
});
// Delay loaded components
export var NotificationToast = createLazyComponent(lazyModule, function (m) { return m.NotificationToast; });
export { addNotification, removeNotification, NotificationActionType, headerToastNotificationStore, ensureNotificationHandlerRegistered, CALL_NOTIFICATION_TYPE, IM_NOTIFICATION_TYPE, SUMMARY_NOTIFICATION_TYPE, };
//# sourceMappingURL=index.js.map